import styled from '@emotion/styled';
import React, { CSSProperties } from 'react';
import { theme } from 'styles/theme/theme';

interface ImGameWordmarkProps {
  className?: string;
  style?: CSSProperties;
}

/**
 * Знак ImGame для экранов оверлея: «Im» жёлтым, «Game» белым — как `UDLogo`, но без `Link`.
 * Оверлей висит в OBS, кликать по нему некому, а роутера в его окружении может и не быть.
 * Общий для шапки чеклиста и лоадера переключения матча, чтобы они не разошлись.
 */
function ImGameWordmark({ className, style }: ImGameWordmarkProps) {
  return (
    <Wordmark className={['text title-1 bold', className].filter(Boolean).join(' ')} style={style} aria-label={'ImGame'}>
      <span>Im</span>Game
    </Wordmark>
  );
}

const Wordmark = styled.span`
  display: inline-block;
  font-size: 22px;
  line-height: 1;
  letter-spacing: 0.01em;
  color: ${theme.colors.InkOnDark};
  user-select: none;

  & > span {
    color: ${theme.colors.DarkYellow};
  }
`;

export default React.memo(ImGameWordmark);
